<section class="main-container">
    <div class="container">
        <div class="page-heading">
            <div class="page-title">
                <h2>{{ sellerName ? sellerName + "'s Products" : 'Seller Products' }}</h2>
            </div>
        </div>

        <div *ngIf="loading" class="text-center py-5">
            <p>{{ 'common.loading' | translate }} ...</p>
        </div>

        <div *ngIf="!loading && offers.length === 0" class="empty-state">
            <div class="empty-icon">
                <i class="fa fa-box-open"></i>
            </div>
            <h3 class="empty-title">No products found for this seller.</h3>
            <p class="empty-subtitle">This seller hasn't listed any products yet.</p>
        </div>

        <div *ngIf="!loading && offers.length > 0">
            <div class="product-grid">
                <div class="product-card" *ngFor="let offer of offers">
                    <a [routerLink]="['/products', offer.product.slug || offer.product.name, offer.id]" class="card-image-wrapper">
                        <img class="card-image" [defaultImage]="'/assets/images/default.jpg'" [lazyLoad]="getImageSrc(offer)" [alt]="offer.product.name" />
                        <div class="discount-badge" *ngIf="isInPromotion(offer)">-{{ offer.percentDiscount }}%</div>
                        <div class="stock-badge" *ngIf="offer.qty > 0 && !offer.availableDate; else outOfStock">{{ 'product.in_stock' | translate }}</div>
                        <ng-template #outOfStock>
                            <div class="stock-badge out-of-stock">{{ 'product.out_of_stock' | translate }}</div>
                        </ng-template>
                    </a>
                    <div class="card-content">
                        <a [routerLink]="['/products', offer.product.slug || offer.product.name, offer.id]" class="product-name">
                            {{ lang === 'fr' ? offer.product.productNameFr : offer.product.productName }}
                        </a>
                        <p class="product-desc">{{ stripHtml(offer.description) }}</p>
                        <div class="product-price">
                            <span class="current-price">{{ getOfferPrice(offer) | number }} {{ offer.currency | uppercase }}</span>
                            <span class="old-price" *ngIf="isInPromotion(offer)">{{ offer.price | number }} {{ offer.currency | uppercase }}</span>
                            <span class="unit-price"> / {{ lang === 'fr' ? offer.measurementunit.descriptionFr : offer.measurementunit.description }}</span>
                        </div>
                        <div class="product-actions">
                            <button *ngIf="!isOfferInCart(offer) && offer.qty > 0 && !offer.availableDate" class="btn-add" (click)="$event.stopPropagation(); addToCart(offer)">
                                <i class="fa fa-shopping-cart"></i>
                                <span>{{ 'common.add_to_cart' | translate }}</span>
                            </button>
                            <button class="btn-like" (click)="$event.stopPropagation(); addToWishlist(offer.id)">
                                <i class="fa fa-heart"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="toolbar" *ngIf="totalItems > itemsPerPage">
                <div class="pager">
                    <pagination-controls
                        class="pages"
                        maxSize="5"
                        [previousLabel]="'common.previous' | translate"
                        [nextLabel]="'common.next' | translate"
                        autoHide="true"
                        (pageChange)="pageChange($event)">
                    </pagination-controls>
                </div>
            </div>
        </div>
    </div>
</section>
